module.exports = __webpack_public_path__ + "static/correct-d27f45adf88f4e70e787423e4db695ad.mp3";